module.exports = function(params) {
    const urlParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        // If value is an array, append each item separately
        value.forEach(item => {
          urlParams.append(key, item);
        });
      } else {
        // If value is not an array, append as is
        urlParams.append(key, value);
      }
    });

    return urlParams.toString()
}